import { Ref } from "@vue/composition-api";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { Subscription } from "@scrile/api-provider/dist/api/SubscriptionProvider";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { handleRequestError } from "@/lib/handleRequestError";
import PaymentManager from "@/payments";
import { PurchaseDetails } from "@/payments/types";
import { ERRORS, EVENTS } from "@/const";

export default function usePurchaseSubscription(
  subscriptionLevel: Ref<SubscriptionLevel | null>,
  purchaseDetails: Ref<PurchaseDetails>
) {
  const subscribeByCard = async (): Promise<boolean> => {
    const response = await PaymentManager.subscribe(purchaseDetails.value);
    return response.status;
  };

  const subscribeWithBalance = async (): Promise<Subscription | undefined> => {
    if (!subscriptionLevel.value) return;
    let response;
    try {
      providers.SubscriptionProvider.setReceiveErrors(false);
      response = await providers.SubscriptionProvider.purchase({ levelId: subscriptionLevel.value.id });
    } catch (e) {
      handleRequestError(e, [
        {
          comparator: e => e.details?.messageTemplate === ERRORS.SPENDING_BALANCE,
          onSuccessCB: () => emitter.emit(EVENTS.BALANCE_REFILL_SHOW),
        },
      ]);
    }
    return response;
  };

  const performPurchaseSubscription = (fromBalance: boolean) => {
    return fromBalance ? subscribeWithBalance() : subscribeByCard();
  };

  return {
    performPurchaseSubscription,
  };
}
